import { get, post } from '@/api'

/**
 * 分页查询线索列表
 * @param {Object} data QueryLeadPoolDTO
 */
export function getLeadPoolPage(data) {
  return post('/lead-pool/page', data)
}

/**
 * 根据ID查询线索详情
 * @param {number|string} id 线索ID
 */
export function getLeadPoolDetail(id) {
  return get(`/lead-pool/${id}`)
}

/**
 * 创建线索
 * @param {Object} data CreateLeadPoolDTO
 */
export function createLeadPool(data) {
  return post('/lead-pool/create', data)
}

/**
 * 更新线索
 * @param {Object} data UpdateLeadPoolDTO（id 必填）
 */
export function updateLeadPool(data) {
  return post('/lead-pool/update', data)
}

/**
 * 删除线索
 * @param {number|string} id 线索ID
 */
export function deleteLeadPool(id) {
  return post(`/lead-pool/delete/${id}`)
}
/**
 * 分页查询线索池变更日志（跟进记录）
 * @param {Object} data QueryLeadPoolChangeLogDTO
 */
export function getLeadPoolChangeLogPage(data) {
  return post('/lead-pool/change-log/page', data)
}
